import searchAtomPair, { type SearchParams } from 'atoms/search-atom';
import type {
  DiscountRateScenarioResult,
  DiscountRateScenarioFacets,
  DiscountRateScenarioAggregations,
} from './types';

export interface DiscountRateScenarioParams extends SearchParams {
  createdBy?: string[];
  createdAt?: { start?: string; end?: string };
  updatedAt?: { start?: string; end?: string };
  effectiveDate?: { start?: string; end?: string };
}

export const createDiscountRateScenarioSearchAtom = () =>
  searchAtomPair<
    DiscountRateScenarioResult,
    DiscountRateScenarioParams,
    DiscountRateScenarioFacets,
    DiscountRateScenarioAggregations
  >({ href: '/queries/discount_rate_scenarios' });
